<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEditGradeLevel()">Edit Grade Level</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onMoveUp()">Move Up</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onMoveDown()">Move Down</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGradeLevel"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedGradeLevel"
		dataKey="GradeLevelID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->
				<!-- <th></th> -->

				<!--GradeLevelCD-->
				<th>
					<p-columnFilter type="text" field="GradeLevelCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--GradeLevelDesc-->
				<th>
					<p-columnFilter type="text" field="GradeLevelDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MealAccountCreditLimit-->
				<th>
					<!-- <p-columnFilter type="text" field="MealAccountCreditLimit" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<!-- <th pSortableColumn="ZOrder">Order<p-sortIcon field="ZOrder"></p-sortIcon></th> -->
				<!-- <th pSortableColumn="GradeLevelCD">Grade Code<p-sortIcon field="GradeLevelCD"></p-sortIcon></th>
                <th pSortableColumn="GradeLevelDesc">Grade<p-sortIcon field="GradeLevelDesc"></p-sortIcon></th>
                <th pSortableColumn="MealAccountCreditLimit">Meal Account Maximum Negative Amount<p-sortIcon field="MealAccountCreditLimit"></p-sortIcon></th> -->

				<th>Grade Code</th>
				<th>Grade</th>
				<th>Meal Account Maximum Negative Amount</th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-GradeLevel>
			<tr [pSelectableRow]="GradeLevel" (dblclick)="onRowDblClick(GradeLevel)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ GradeLevel[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
